
/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
  mutation ReportCreateMutation($startDate: String!, $endDate: String!, $tableName: String!, $email: String!) {
    ReportCreate(startDate: $startDate, endDate: $endDate, tableName: $tableName, email: $email) {
      count
      downloadId
      message
      status
    }
  }
`
